import { createAsyncThunk } from '@reduxjs/toolkit';

import { getAirdropsAsync } from './Airdrop.request';

export const getAirdrops = createAsyncThunk('getAirdrops', async () => {
  const tokens = await getAirdropsAsync();

  return tokens;
});
